import {createContext} from "react";
const  userdataContext= createContext();
 export  default userdataContext;